import Button from "./button";
import Text from "./text";
import Heading from "./heading";
import FormLabel from "./form-label";
import Table from "./table";
import { tabsTheme } from "./tabs";
import Input from "./input";

const components = {
  Button,
  Text,
  Heading,
  FormLabel,
  Table,
  Tabs: tabsTheme,
  Input,
};

export default components;
